/**
 * WebSocket Event Types
 * Centralized event definitions for type-safe communication
 */
export var WSEvent;
(function (WSEvent) {
    // Connection lifecycle
    WSEvent["CONNECT"] = "connect";
    WSEvent["DISCONNECT"] = "disconnect";
    WSEvent["ERROR"] = "error";
    // Authentication
    WSEvent["AUTH_LOGIN"] = "auth:login";
    WSEvent["AUTH_LOGOUT"] = "auth:logout";
    WSEvent["AUTH_SUCCESS"] = "auth:success";
    WSEvent["AUTH_FAILED"] = "auth:failed";
    // Job events
    WSEvent["JOB_CREATED"] = "job:created";
    WSEvent["JOB_UPDATED"] = "job:updated";
    WSEvent["JOB_STARTED"] = "job:started";
    WSEvent["JOB_COMPLETED"] = "job:completed";
    WSEvent["JOB_FAILED"] = "job:failed";
    WSEvent["JOB_DELETED"] = "job:deleted";
    WSEvent["JOB_ASSIGN"] = "job:assign";
    WSEvent["JOB_ACCEPT"] = "job:accept";
    WSEvent["JOB_REJECT"] = "job:reject";
    WSEvent["JOB_PROGRESS"] = "job:progress";
    // Result events (public - broadcast to all users)
    WSEvent["RESULT_ADDED"] = "result:added";
    WSEvent["RESULT_UPDATED"] = "result:updated";
    WSEvent["RESULT_DELETED"] = "result:deleted";
    WSEvent["RESULT_JOB_CREATED"] = "result:job_created";
    WSEvent["RESULT_JOB_UPDATED"] = "result:job_updated";
    WSEvent["RESULT_JOB_COMPLETED"] = "result:job_completed";
    WSEvent["RESULT_JOB_DELETED"] = "result:job_deleted";
    // Favorite events
    WSEvent["FAVORITE_ADDED"] = "favorite:added";
    WSEvent["FAVORITE_REMOVED"] = "favorite:removed";
    WSEvent["FAVORITES_CLEARED"] = "favorites:cleared";
    WSEvent["JOB_FAVORITE_ADDED"] = "job_favorite:added";
    WSEvent["JOB_FAVORITE_REMOVED"] = "job_favorite:removed";
    // Queue events
    WSEvent["QUEUE_UPDATED"] = "queue:updated";
    WSEvent["GLOBAL_PAUSE_CHANGED"] = "global_pause:changed";
    // Share events
    WSEvent["SHARE_CREATED"] = "share:created";
    WSEvent["SHARE_UPDATED"] = "share:updated";
    WSEvent["SHARE_DELETED"] = "share:deleted";
    WSEvent["SHARES_CLEARED"] = "shares:cleared";
    // Notification events
    WSEvent["NOTIFICATION"] = "notification";
    WSEvent["NOTIFICATION_CREATED"] = "notification:created";
    WSEvent["NOTIFICATION_READ"] = "notification:read";
    WSEvent["NOTIFICATION_DELETED"] = "notification:deleted";
    // Log events
    WSEvent["LOG_CREATED"] = "log:created";
    // System events
    WSEvent["CONFIG_UPDATED"] = "config:updated";
    WSEvent["STATS_UPDATED"] = "stats:updated";
    WSEvent["USER_UPDATED"] = "user:updated";
    WSEvent["USER_CONNECTED"] = "user:connected";
    WSEvent["USER_DISCONNECTED"] = "user:disconnected";
    // Variant events
    WSEvent["VARIANT_CREATED"] = "variant:created";
    WSEvent["VARIANT_APPROVED"] = "variant:approved";
    WSEvent["VARIANT_UPDATED"] = "variant:updated";
    WSEvent["VARIANT_DELETED"] = "variant:deleted";
    WSEvent["VARIANT_TYPE_CHANGED"] = "variant:type_changed";
    WSEvent["VARIANTS_TYPE_BULK_CHANGED"] = "variants:type_bulk_changed";
    // Scraper config events
    WSEvent["SCRAPER_CONFIG_UPDATED"] = "scraper_config:updated";
    WSEvent["SCRAPER_CONFIG_ACTIVATED"] = "scraper_config:activated";
    // Tag events
    WSEvent["TAG_CREATED"] = "tag:created";
    WSEvent["TAG_UPDATED"] = "tag:updated";
    WSEvent["TAG_DELETED"] = "tag:deleted";
    WSEvent["TAG_ADDED_TO_RESULT"] = "tag:added_to_result";
    WSEvent["TAG_REMOVED_FROM_RESULT"] = "tag:removed_from_result";
    // Note events
    WSEvent["NOTE_CREATED"] = "note:created";
    WSEvent["NOTE_UPDATED"] = "note:updated";
    WSEvent["NOTE_DELETED"] = "note:deleted";
    WSEvent["NOTES_CLEARED"] = "notes:cleared";
    // Proxy events
    WSEvent["PROXY_ASSIGNED"] = "proxy:assigned";
    WSEvent["PROXY_FAILED"] = "proxy:failed";
    WSEvent["PROXY_PROVIDER_CHANGED"] = "proxy_provider:changed";
    WSEvent["PROXY_PROVIDER_SYNC_COMPLETE"] = "proxy_provider:sync_complete";
    WSEvent["PROXY_RECOVERED"] = "proxy:recovered";
    WSEvent["PROXY_COOLDOWN_SET"] = "proxy:cooldown_set";
    WSEvent["PROXY_POOL_WARNING"] = "proxy:pool_warning";
    // Fingerprint events
    WSEvent["FINGERPRINT_ASSIGNED"] = "fingerprint:assigned";
    // Detection events
    WSEvent["CAPTCHA_DETECTED"] = "captcha:detected";
    WSEvent["RATE_LIMIT_DETECTED"] = "rate_limit:detected";
    // Scraping control events
    WSEvent["SCRAPING_PAUSED"] = "scraping:paused";
    WSEvent["SCRAPING_RESUMED"] = "scraping:resumed";
    WSEvent["SCRAPING_AUTO_PAUSED"] = "scraping:auto_paused";
    // Browser profile events
    WSEvent["BROWSER_PROFILE_CREATED"] = "browserProfile:created";
    WSEvent["BROWSER_PROFILE_UPDATED"] = "browserProfile:updated";
    WSEvent["BROWSER_PROFILE_DELETED"] = "browserProfile:deleted";
    WSEvent["BROWSER_PROFILE_CLEANUP"] = "browserProfile:cleanup";
    WSEvent["BROWSER_PROFILE_ERROR"] = "browserProfile:error";
    // Batch import events (Phase 22.3)
    WSEvent["BATCH_IMPORT_PROGRESS"] = "batch_import:progress";
    WSEvent["BATCH_IMPORT_PROCESSING_STARTED"] = "batch_import:processing_started";
    WSEvent["BATCH_IMPORT_COMPLETED"] = "batch_import:completed";
    WSEvent["BATCH_IMPORT_ERROR"] = "batch_import:error";
    // Batch list events (public - broadcast to all users)
    WSEvent["BATCH_LIST_CREATED"] = "batch_list:created";
    WSEvent["BATCH_LIST_UPDATED"] = "batch_list:updated";
    WSEvent["BATCH_LIST_DELETED"] = "batch_list:deleted";
})(WSEvent || (WSEvent = {}));
/**
 * WebSocket Room Types
 * For targeted broadcasting
 */
export var WSRoom;
(function (WSRoom) {
    WSRoom["GLOBAL"] = "global";
    WSRoom["ADMIN"] = "admin";
    WSRoom["USER_PREFIX"] = "user:";
    WSRoom["JOB_PREFIX"] = "job:";
    WSRoom["SHARE_PREFIX"] = "share:";
})(WSRoom || (WSRoom = {}));
//# sourceMappingURL=events.js.map